import {lazy} from 'react';

import {FoodDiaryPageLayout} from '@src/v2/pages/FoodDiaryPageLayout';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {foodDiaryRoutesPath} from './path';

const FoodDiaryOnboardingPage = Loadable(
  lazy(
    () =>
      import(
        '@src/v2/pages/FoodDiaryOnboardingPage' /* webpackChunkName: "food-diary-onboarding-page" */
      ),
  ),
);
const FoodDiaryPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/FoodDiaryPage' /* webpackChunkName: "food-diary-page" */
    ).then(module => ({default: module.FoodDiaryPage})),
  ),
);

const FoodDiaryMealPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/FoodDiaryMealPage' /* webpackChunkName: "food-diary-meal-page" */
    ).then(module => ({default: module.FoodDiaryMealPage})),
  ),
);

const FoodDiaryTrackersPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/FoodDiaryTrackersPage' /* webpackChunkName: "food-diary-trackers-page" */
    ).then(module => ({default: module.FoodDiaryTrackersPage})),
  ),
);

export const foodDiaryRoutes = [
  {
    children: [
      {
        element: <FoodDiaryPage />,
        path: foodDiaryRoutesPath.foodDiary.$path(),
      },
      {
        element: <FoodDiaryMealPage />,
        path: foodDiaryRoutesPath.foodDiary.meal.$path(),
      },
      {
        element: <FoodDiaryTrackersPage />,
        path: foodDiaryRoutesPath.foodDiary.editTrackers.$path(),
      },
    ],
    element: <FoodDiaryPageLayout />,
  },
  {
    element: <FoodDiaryOnboardingPage />,
    path: foodDiaryRoutesPath.foodDiaryOnboarding.$path(),
  },
] satisfies RouteConfig[];
